<template>
	<Modal :show="show" @close="close" size="lg" :hideFooter="true" bodyClasses="mb-0">
		<template v-slot:header>
			<h5 class="modal-title">Forgot password?</h5>
		</template>
		<div>
			<p class="text-muted">
				Enter the email address associated with your account and we'll send you a link to reset your password.
			</p>
			<base-input
				alternative
				name="Email"
				prepend-icon="ni ni-email-83"
				placeholder="Email"
				v-model="email"
			>
			</base-input>
			<div v-if="resultMessage" :class="resultIsError ? 'text-danger' : 'text-success'" class="mt-2">
				<small>{{ resultMessage }}</small>
			</div>
			<div class="text-center mt-3">
				<base-button type="primary" block :disabled="isLoading || !email" @click="submit">
					{{ isLoading ? 'Checking...' : 'Send Reset Email' }}
				</base-button>
			</div>
		</div>
	</Modal>
</template>
<script>
import Modal from './Modal.vue';
import { functions, auth } from '../../resources/firebase';
import { httpsCallable } from 'firebase/functions';
import { sendPasswordResetEmail } from 'firebase/auth';

export default {
	name: 'forgot-password-modal',
	components: { Modal },
	props: {
		show: { type: Boolean, default: false },
		organization: { type: Object, default: null },
	},
	data() {
		return {
			email: '',
			isLoading: false,
			resultMessage: null,
			resultIsError: false,
		};
	},
	methods: {
		close() {
			this.email = '';
			this.resultMessage = null;
			this.resultIsError = false;
			this.$emit('close');
		},
		submit() {
			if (!this.email || !this.organization) return;
			this.isLoading = true;
			this.resultMessage = null;

			const checkStatus = httpsCallable(functions, 'checkForgotPasswordStatus');
			checkStatus({ email: this.email, organization: this.organization })
				.then((result) => {
					const status = result.data.status;
					if (status === 'central_account') {
						return sendPasswordResetEmail(auth, this.email).then(() => {
							this.resultIsError = false;
							this.resultMessage = 'Check your email for a link to reset your portal password.';
						});
					} else if (status === 'temp_invite_resent') {
						this.resultIsError = false;
						this.resultMessage =
							"You haven't activated your account yet — we've resent your setup email. Complete it in the mobile app (not here), using the temporary password from that email.";
					} else {
						this.resultIsError = true;
						this.resultMessage = "We couldn't find an account for that email. Contact support for help.";
					}
				})
				.catch((error) => {
					this.resultIsError = true;
					this.resultMessage = error.message || 'Something went wrong. Please try again.';
				})
				.finally(() => {
					this.isLoading = false;
				});
		},
	},
};
</script>
